
// Заглушка на случай отсутствия капчи
/**@see https://ru.wikipedia.org/wiki/Null_object_(%D1%88%D0%B0%D0%B1%D0%BB%D0%BE%D0%BD_%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F)*/

/**@param {Object} options*/
export function ChiliCommentsNoCaptcha (options){

    if(!new.target){
        return new ChiliCommentsNoCaptcha(options);
    }

    this.options = options;

    this.options.invisible = true;

    let eventListeners = {};

    this.addEventListener = (event, listener) => {

        if (!eventListeners[event]) {
            eventListeners[event] = [];
        }

        eventListeners[event].push(listener);
    }

    this.emit = (event, data)  => {
        if (eventListeners[event]) {
            eventListeners[event].forEach((listener) => {
                if(typeof listener === "function"){
                    listener(data)
                }
            });
        }
    }

    /**@param {HTMLElement} form*/
    this.render = (form) => {
        // no methods
    };

    /**@param {HTMLElement} form*/
    this.check = (form) => {
        this.emit('captcha-success', {form: form});
    }

    this.setPublicKey = (publicKey) => {
        return true;
    }

    this.isDependedCaptcha = () => {
        return true;
    }

    return this;

}
